module.exports = __webpack_public_path__ + "assets/3e14224fe0a6a4e01867b819b6d5181b.png";